import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { route } from "../../router/route";
import PretendardText from "../atoms/text/pretendardText";
import scrollToTop from "../../util/scrollToTop";

const Sidebar = (props) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(0);

  // 마운트 시
  useEffect(() => {
    const myInfo = JSON.parse(sessionStorage.getItem("wc_admin_myInfo"));
    setMyInfo(myInfo);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [myInfo, setMyInfo] = useState({});

  //경로 저장
  const location = useLocation();
  const [path, setPath] = useState(null);
  const [menus, setMenus] = useState([
    // 홈 영역
    {
      title: "홈",
      link: route.home,
      subMenus: [],
      isView: true,
    },
    // 쇼핑 영역
    {
      title: "쇼핑",
      link: route.shopping,
      subMenus: [
        {
          title: "상품관리",
          link: route.shopping_product,
          isView: true,
        },
        {
          title: "판매관리",
          link: route.shopping_sell,
          isView: true,
        },
        {
          title: "멤버십 상품관리",
          link: route.shopping_membership_product,
          isView: true,
        },
        {
          title: "멤버십 판매관리",
          link: route.shopping_membership_sell,
          isView: true,
        },
        {
          title: "후기관리",
          link: route.shopping_review,
          isView: true,
        },
      ],
      isView: true,
    },
    // 회원관리 영역
    {
      title: "회원관리",
      link: route.user,
      subMenus: [
        {
          title: "회원정보",
          link: route.user_info,
          isView: true,
        },
        {
          title: "멤버십 회원정보",
          link: route.user_membership_info,
          isView: true,
        },
        {
          title: "멤버십 대기명단",
          link: route.user_membership_waiting_list,
          isView: true,
        },
        {
          title: "무료 PDF 신청 명단",
          link: route.user_pdf_application_list,
          isView: true,
        },
        {
          title: "운영진 설정",
          link: route.user_admin,
          isView: true,
        },
        {
          title: "구매제한 회원",
          link: route.user_purchase_limit,
          isView: true,
        },
        {
          title: "탈퇴 회원",
          link: route.user_withdraw,
          isView: true,
        },
      ],
      isView: true,
    },
    // 통계
    {
      title: "통계",
      link: route.statistics,
      subMenus: [
        {
          title: "홈",
          link: route.statistics_home,
          isView: true,
        },
        {
          title: "매출",
          link: route.statistics_sales,
          isView: true,
        },
        {
          title: "기간별 분석",
          link: route.statistics_period,
          isView: true,
        },
        // {
        //   title: "유입 사이트",
        //   link: route.statistics_inflow_site,
        //   isView: false,
        // },
        // {
        //   title: "유입 검색어",
        //   link: route.statistics_inflow_search,
        //   isView: false,
        // },
        {
          title: "방문자",
          link: route.statistics_visitor,
          isView: true,
        },
        // {
        //   title: "많이 방문한 페이지",
        //   link: route.statistics_most_visited,
        //   isView: false,
        // },
        // {
        //   title: "시간대별 조회수",
        //   link: route.statistics_time,
        //   isView: true,
        // },
        {
          title: "성별·연령별 조회수",
          link: route.statistics_gender_age,
          isView: true,
        },
        {
          title: "멤버십 분석",
          link: route.statistics_analysis,
          isView: true,
        },
        {
          title: "멤버십 해지분석",
          link: route.statistics_cancel,
          isView: true,
        },
      ],
      isView: true,
    },
    // 운영 관리
    {
      title: "운영 관리",
      link: route.operation,
      subMenus: [
        {
          title: "쿠폰",
          link: route.operation_coupon,
          isView: true,
        },
        {
          title: "메시지 보내기",
          // link: route.operation_message_alarm,
          link: route.operation_message,
          isView: true,
        },
        {
          title: "공지사항 관리",
          link: route.operation_notice,
          isView: true,
        },
        {
          title: "포인트 관리",
          link: route.operation_point,
          isView: true,
        },
        {
          title: "레벨 설정 관리",
          link: route.operation_level,
          isView: true,
        },
        {
          title: "자주 묻는 질문 관리",
          link: route.operation_faq,
          isView: true,
        },
        {
          title: "1:1 문의 내역 관리",
          link: route.operation_ask,
          isView: true,
        },
        {
          title: "팝업/배너 관리",
          link: route.operation_popup_banner,
          isView: true,
        },
        {
          title: "약관 관리",
          link: route.operation_terms,
          isView: true,
        },
        // {
        //   title: "데이터 연결",
        //   link: route.operation_data,
        //   isView: true,
        // },
        // {
        //   title: "상담채널 연동",
        //   link: route.operation_consult,
        //   isView: true,
        // },
      ],
      isView: true,
    },
    // 일급비밀 관리
    {
      title: "일급비밀 관리",
      link: route.secret,
      subMenus: [
        {
          title: "일급비밀 상세페이지",
          link: route.secret_detail,
          isView: true,
        },
        {
          title: "멤버십 QnA 관리",
          link: route.secret_qna,
          isView: true,
        },
        {
          title: "자료창고 관리",
          link: route.secret_archive,
          isView: true,
        },
      ],
      isView: true,
    },
    // 지식상점 관리
    {
      title: "지식상점 관리",
      link: route.knowledge,
      subMenus: [
        {
          title: "지식상점 홈 배너",
          link: route.knowledge_banner,
          isView: true,
        },
        {
          title: "Vu: 관리",
          link: route.knowledge_vu,
          isView: true,
        },
        {
          title: "커리큘럼 관리",
          link: route.knowledge_curriculum,
          isView: true,
        },
        {
          title: "첫 방문이라면? 관리",
          link: route.knowledge_first_visit,
          isView: true,
        },
      ],
      isView: true,
    },
    // 커뮤니티 관리
    {
      title: "커뮤니티 관리",
      link: route.community,
      subMenus: [
        {
          title: "커뮤니티 관리",
          link: route.community_management,
          isView: true,
        },
        {
          title: "라이팅크루가 처음이라면?",
          link: route.community_first,
          isView: true,
        },
      ],
      isView: true,
    },
    // 멤버십 전용 관리
    {
      title: "멤버십 전용 관리",
      link: route.crew,
      subMenus: [
        {
          title: "멤버십 가이드",
          link: route.crew_guide,
          isView: true,
        },
        {
          title: "라이팅링크",
          link: route.crew_link,
          isView: true,
        },
      ],
      isView: true,
    },
  ]);

  useEffect(() => {
    setPath(location.pathname);

    const accessMenu = sessionStorage.getItem("accessMenu");

    // 추후 최고 관리자는 권한 다 줘야하는데 어떻게 줘야할지 정해야함함
    // if (accessMenu) {
    for (let index = 0; index < menus.length; index++) {
      const element = menus[index];
      if (element.subMenus.length > 0) {
        for (let index2 = 0; index2 < element.subMenus.length; index2++) {
          const element2 = element.subMenus[index2];
          if (!accessMenu?.includes(element2.link)) {
            element2.isView = false;
          }
        }
        if (
          element.subMenus.filter((item) => !item.isView).length ===
          element.subMenus.length
        ) {
          element.isView = false;
        }
      } else {
        if (!accessMenu?.includes(element.link)) {
          element.isView = false;
        }
      }
    }
    setMenus([...menus]);
    // }
  }, [location]);

  return (
    <SidebarWrapper style={{ ...props.style }}>
      <ProfileWrapper>
        <img src="/assets/admin/icons/ico_profile.svg" alt="" />
        <SidebarPretendardText
          style={{
            color: "#fff",
            fontSize: "14px",
            fontWeight: "600",
            letterSpacing: "-0.042px",
            cursor: "unset",
          }}
        >
          {myInfo.email || ""}
        </SidebarPretendardText>
      </ProfileWrapper>
      <NavListWrapper>
        {menus.map((item, index) => {
          return (
            <div key={index}>
              {item.isView ? (
                <NavWrapper
                  onClick={() => {
                    if (item.subMenus.length > 0) {
                      isOpen === item.link
                        ? setIsOpen(0)
                        : setIsOpen(item.link);
                    } else {
                      navigate(item.link);
                      scrollToTop();
                      sessionStorage.removeItem("tab");
                    }
                  }}
                >
                  <SidebarPretendardText
                    style={{
                      color: `${path?.includes(item.link) ? "#27BEFF" : ""}`,
                    }}
                  >
                    {item.title}
                  </SidebarPretendardText>
                  {item.subMenus.length > 0 ? (
                    <PretendardText
                      style={{
                        width: "12px",
                        height: "12px",
                        color: `${
                          path?.includes(item.link) ? "#27BEFF" : "#F2F4F5"
                        }`,
                      }}
                    >
                      {path?.includes(item.link) || isOpen === item.link
                        ? "-"
                        : "+"}
                    </PretendardText>
                  ) : null}
                </NavWrapper>
              ) : null}
              <SubmenuListWrapper>
                {item.subMenus.length > 0
                  ? item.subMenus.map((item2, index2) => {
                      return path?.includes(item.link) ||
                        isOpen === item.link ? (
                        <>
                          {item2.isView ? (
                            <div key={index2}>
                              <SubmenuWrapper
                                onClick={() => {
                                  navigate(item2.link);
                                  scrollToTop();
                                  sessionStorage.removeItem("tab");
                                }}
                                style={{
                                  backgroundColor: `${
                                    path?.includes(item2.link)
                                      ? "#ffffff10"
                                      : ""
                                  }`,
                                  cursor: "pointer",
                                }}
                              >
                                <SubPretendardText
                                  style={{
                                    color: `${
                                      path?.includes(item2.link) ? "#FFF" : ""
                                    }`,
                                  }}
                                >
                                  {item2.title}
                                </SubPretendardText>
                              </SubmenuWrapper>
                            </div>
                          ) : null}
                        </>
                      ) : null;
                    })
                  : null}
              </SubmenuListWrapper>
            </div>
          );
        })}
      </NavListWrapper>
    </SidebarWrapper>
  );
};

export default Sidebar;

const SidebarWrapper = styled.div.attrs((props) => {})`
  min-width: 265px;
  max-width: 265px;
  min-height: 100vh;
  height: auto;
  background-color: #272829;
  padding-top: 80px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  position: relative;
  z-index: 5;
`;

const ProfileWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 58px;
  padding: 10px 25px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const NavListWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
`;

const NavWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 25px;
  cursor: pointer;
`;

const SidebarPretendardText = styled(PretendardText).attrs((props) => {})`
  color: #f2f4f5;
  font-size: 18px;
  font-weight: 600;
  line-height: 32.5px;
  letter-spacing: -0.054px;
  cursor: pointer;
`;

const SubmenuListWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 13.5px;
`;

const SubmenuWrapper = styled.div.attrs((props) => {})`
  width: 236px;
  height: 46px;
  display: flex;
  align-items: center;
  padding: 14px 25px;
  border-radius: 8px;
`;

const SubPretendardText = styled(PretendardText).attrs((props) => {})`
  color: #778088;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.048px;
  cursor: pointer;
`;
